import { Navigate, useLocation, useParams } from "react-router-dom";

/** Leagues moved from /leagues/v2 to /leagues; old links keep their page. */
export function LeaguesV2PathRedirect() {
  const { "*": rest } = useParams();
  const { search, hash } = useLocation();
  return (
    <Navigate
      to={`/leagues${rest ? `/${rest}` : ""}${search}${hash}`}
      replace
    />
  );
}
